import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import SearchIcon from "@mui/icons-material/Search";
import SearchAssetView from "../SearchAssetView";
import WizardStepDialog from "./WizardStepDialog";
import { LOCATION_SNAPSHOT_ADD_ITEM_STEPS, getLocationSnapshotAddItemStepMeta } from "../../steps";

const { SEARCH } = LOCATION_SNAPSHOT_ADD_ITEM_STEPS;

export default function SearchStepDialog({
  open,
  onClose,
  searchCode,
  setSearchCode,
  handleSearch,
  searchLoading,
  searchError,
  onBack,
}) {
  const { step, steps } = getLocationSnapshotAddItemStepMeta(SEARCH);
  const canSearch = Boolean(searchCode.trim()) && !searchLoading;

  return (
    <WizardStepDialog
      open={open}
      title="Inventory Move Search"
      onClose={onClose}
      step={step}
      steps={steps}
      actions={
        <Box display="flex" gap={1}>
          <Button variant="outlined" onClick={onBack} disabled={searchLoading}>
            Back
          </Button>
          <Button
            variant="contained"
            onClick={handleSearch}
            disabled={!canSearch}
            startIcon={<SearchIcon />}
          >
            Search
          </Button>
        </Box>
      }
    >
      <SearchAssetView
        searchCode={searchCode}
        setSearchCode={setSearchCode}
        handleSearch={handleSearch}
        searchLoading={searchLoading}
        searchError={searchError}
      />
    </WizardStepDialog>
  );
}
